export const mobileAppLogos = {
  android: '/assets/mobile-apps/android-app.png',
  ios: '/assets/mobile-apps/ios-app.png',
}
